/* custom-product.js — product page only (loaded by snippets/custom-globals.liquid)
   One thing anchored at the bottom of the screen at a time. The floating
   WhatsApp button tucks away (body[data-wa-tucked], styled in
   custom-theme.css) while:
   1. the inline WhatsApp help card (blocks/custom-product-assurance.liquid)
      is on screen — one chat entry point at a time; or
   2. on phones, Horizon's sticky Add to cart bar is showing — that bar is
      full-width at the bottom there, so the button would otherwise jump up
      over the page content. (On wider screens the bar is a centred 600px
      pill that never meets the corner button, so nothing moves.)
   Reuses Horizon's own state: the bar's data-stuck attribute. */
import { StandardEvents } from '@shopify/events';

const help = document.querySelector('.product-trust__help');
const bar = document.querySelector('.sticky-add-to-cart__bar');
const phone = matchMedia('(max-width: 749px)');
let helpVisible = false;
let returnTimer = 0;
// Horizon's bar slides out in 300ms: bring the button back only once it's gone
const RETURN_DELAY = 300;

function update() {
  const barShowing = bar?.getAttribute('data-stuck') === 'true' && !!bar.closest('sticky-add-to-cart[data-variant-available="true"]');
  const tuck = helpVisible || (phone.matches && barShowing);
  clearTimeout(returnTimer);
  if (tuck) document.body.setAttribute('data-wa-tucked', '');
  else returnTimer = setTimeout(() => document.body.removeAttribute('data-wa-tucked'), RETURN_DELAY);
}

if (help && 'IntersectionObserver' in window) {
  new IntersectionObserver(([entry]) => {
    helpVisible = entry.isIntersecting;
    update();
  }).observe(help);
}

if (bar) {
  new MutationObserver(update).observe(bar, { attributes: true, attributeFilter: ['data-stuck'] });
  const wrapper = bar.closest('sticky-add-to-cart');
  if (wrapper) new MutationObserver(update).observe(wrapper, { attributes: true, attributeFilter: ['data-variant-available'] });
}

phone.addEventListener('change', update);
update();

/* Specifications tab: the SKU row follows the selected variant. The tab lives
   in its own section (sections/custom-product-tabs.liquid), outside the
   product section Horizon re-renders, so it showed the first variant's SKU
   after a colour / size change. Horizon announces the new variant with the
   standard productSelect event; its promise resolves with the variant. */
document.addEventListener(StandardEvents.productSelect, (event) => {
  // Only the main product: cards and quick-add fire the same event
  if (!(event.target instanceof Element) || !event.target.closest('[id*="ProductInformation-"]')) return;
  const promise = /** @type {{ promise?: Promise<{ detail?: { resource?: { sku?: string | null } } }> }} */ (
    /** @type {unknown} */ (event)
  ).promise;
  promise
    ?.then(({ detail }) => {
      const resource = detail?.resource;
      if (!resource) return;
      const sku = resource.sku || '';
      for (const cell of document.querySelectorAll('[data-variant-sku]')) {
        cell.textContent = sku;
        const row = cell.closest('.q-specs__row');
        if (row instanceof HTMLElement) row.hidden = !sku;
      }
    })
    .catch(() => {});
});
